import React from 'react';
import { isEmpty } from '../../helpers';
import * as S from './styles';
import { Text } from '../Text';
export const SuperiorContent = _ref => {
  let {
    label,
    id,
    link,
    size
  } = _ref;
  if (isEmpty(label)) return React.createElement(React.Fragment, null);
  const SuperiorContentLabel = size === 'medium' ? Text.BodyMedium : Text.BodySmall;
  return React.createElement(S.SuperiorContentWrapper, {
    size: size
  }, React.createElement(SuperiorContentLabel, {
    htmlFor: id,
    tag: "label",
    weight: "semibold"
  }, label), link && link);
};